import { render, staticRenderFns } from "./BtnDetalharAplicacao.vue?vue&type=template&id=4a20a9d9&"
import script from "./BtnDetalharAplicacao.vue?vue&type=script&lang=js&"
export * from "./BtnDetalharAplicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports